import { Pipe, PipeTransform } from '@angular/core'

/**
 * A utility pipe to cast template variables to a specific type.
 * Usage: {{ value | as: 'string' }} or [prop]="value | as: templateRefType"
 */
@Pipe({
	name: 'asType'
})
export class AsTypePipe implements PipeTransform {
	// The 'typeToken' is never used at runtime, only for TS inference
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	transform<T>(value: unknown, typeToken?: T): T {
		return value as T
	}
}
